<template>
  <div class="mask-preview" ref="maskPreview">
    <mask-preview-render
      :height="height"
      :material="material"
      :timestamp="timestamp"
      :customization="customization"
      @canvas="(e) => $emit('canvas', e)"
    >
      <div
        v-if="imageGroup"
        @click="hideImageGroup = !hideImageGroup"
        class="mask-preview__image-group"
        :class="{ 'mask-preview__image-group--hide': hideImageGroup }"
        :style="{ backgroundImage: `url(${imageGroup})` }"
      ></div>
    </mask-preview-render>
  </div>
</template>

<script>
import MaskPreviewRender from "./mask-preview-render/MaskPreviewRender.vue";
import { getSimilarGroup } from "@/api/catalog-api/similar-group-api/similarGroup.api.js";

export default {
  components: { MaskPreviewRender },
  props: {
    material: String,
    timestamp: [Number, String],
    customization: Object,
  },
  data() {
    return {
      height: null,
      imageGroup: null,
      hideImageGroup: false,
    };
  },
  methods: {
    // TODO: Colocar essa função para renderizar os grupos, renderiza menos e se quiser ver mais seria outra ação.
    // getGroups() {
    //   let groups, materials;
    //   await Promise.all([
    //     getCaseDevices().then((r) => (materials = r)),
    //     getSimilarGroup().then((r) => (groups = r.groups))
    //   ])
    //   const response = groups.map((g) => {
    //     let material
    //     g.devices.find((gd) => {
    //       if (!material)
    //         material = ["wireless-charger", "wireless-car-charger", "gripwhite", "gripblack", "doubleportcustom"].find((m) => m.includes(gd))
    //       if (!material)
    //         material = materials.materials.find((m) => m.includes(gd))
    //     })
    //     return {
    //       material,
    //       image: g.stamp,
    //     }
    //   })
    // }
  },
  async mounted() {
    getSimilarGroup().then(
      (r) =>
        (this.imageGroup = r.groups.find((g) =>
          g.devices.includes(this.material.split("-")[1])
        )?.stamp)
    );
    this.height = this.$refs.maskPreview.offsetHeight * 0.8;
  },
};
</script>

<style lang="scss" scoped>
.mask-preview {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;

  &__image-group {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.2;
    background-size: 100% 100%;

    &--hide {
      opacity: 0;
    }
  }
}
</style>
